import toggleBodyScroll from './toggleBodyScroll';

export const initClientReviews = () => {
  const openButton = document.getElementsByClassName('client-review-button');
  const window = document.getElementsByClassName('client-reviews');
  const closeButton = document.getElementsByClassName('client-reviews__closebutton__icon');

  if (openButton.length === 0 || window.length === 0) {
    return;
  }

  openButton[0].addEventListener('click', () => {
    if (!window[0].classList.contains('--show')) {
      window[0].classList.add('--show');
    }

    setTimeout(toggleBodyScroll(), 500);
  });

  closeButton[0].addEventListener('click', () => {
    if (window[0].classList.contains('--show')) {
      window[0].classList.remove('--show');
    }

    setTimeout(toggleBodyScroll(), 500);
  });
};
